const GreenTick = ({ className }) => {
  return (
    <svg
      className={className}
      width="44"
      height="43"
      viewBox="0 0 44 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44 21.4897L39.12 15.7783L39.8 8.21787L32.58 6.53321L28.8 0L22 2.99952L15.2 0L11.42 6.53321L4.2 8.19732L4.88 15.7578L0 21.4897L4.88 27.2011L4.2 34.7821L11.42 36.4668L15.2 43L22 39.9799L28.8 42.9795L32.58 36.4463L39.8 34.7616L39.12 27.2011L44 21.4897ZM18 31.7621L10 23.5442L12.82 20.6474L18 25.9479L31.18 12.409L34 15.3263L18 31.7621Z"
        fill="#76B900"
      />
    </svg>
  );
};

export default GreenTick;
